import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens } from './tokens';

export const StyledTicksMeter = styled.div`
    ${styledReset.borderBox};
    display: grid;
    grid-auto-flow: column;
    gap: ${tokens.segment.gutter}px;
    width: 100%;
`;
